import { createFileRoute } from "@tanstack/react-router"

import { UpdatePasswordRouteComponent } from "@/routes/_authenticated/account/update-password"

export const Route = createFileRoute(
  "/qr/$qrLookupID/_authenticated/account/update-password"
)({
  staticData: {
    pageName: "Update Password",
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <UpdatePasswordRouteComponent />
}
